import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { log } from "src/app/common/logger";
import { TabComponent } from "src/app/core/tab-component";

const logger = log("TabCanDeactivateGuard");

@Injectable()
export class TabCanDeactivateGuard {
  async canDeactivate(
    component: TabComponent | null,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Promise<boolean> {
    if (component && component.canDeactivate) {
      try {
        logger.info("canDeactivate", " ", component);
        return await component.canDeactivate();
      } catch (e) {
        return false;
      }
    }

    return true;
  }
}
